<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 22 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.4488 17.3854C5.4488 16.9366 5.1374 16.669 4.58798 16.669C4.36362 16.669 4.21168 16.6911 4.1322 16.7123V18.1522C4.2263 18.1734 4.34199 18.1804 4.50144 18.1804C5.08707 18.1804 5.4488 17.8846 5.4488 17.3854Z"
      fill="white"
    />
    <path
      d="M8.84999 16.6841C8.60394 16.6841 8.44494 16.7054 8.35089 16.7274V19.9162C8.44499 19.9383 8.59694 19.9383 8.73431 19.9383C9.73245 19.9454 10.3834 19.3959 10.3834 18.2317C10.3905 17.2194 9.7973 16.6841 8.84999 16.6841Z"
      fill="white"
    />
    <path
      d="M15.1692 0H4.3159C2.73033 0 1.43985 1.29138 1.43985 2.87605V13.5112H1.15894C0.518995 13.5112 0 14.0297 0 14.6702V21.6987C0 22.3391 0.518939 22.8576 1.15894 22.8576H1.43985V24.1464C1.43985 25.7328 2.73033 27.0224 4.3159 27.0224H19.1248C20.7094 27.0224 22 25.7327 22 24.1464V6.80685L15.1692 0ZM3.04038 15.9386C3.38002 15.8812 3.85743 15.8379 4.53005 15.8379C5.20979 15.8379 5.69426 15.9677 6.01978 16.2283C6.33073 16.4739 6.54057 16.8793 6.54057 17.3563C6.54057 17.8333 6.38156 18.2388 6.09225 18.5135C5.71595 18.8677 5.15946 19.0267 4.50847 19.0267C4.36359 19.0267 4.23373 19.0195 4.13217 19.0055V20.7483H3.04038V15.9386ZM19.1248 25.2611H4.3159C3.70196 25.2611 3.20202 24.7612 3.20202 24.1464V22.8576H17.0069C17.647 22.8576 18.1659 22.3391 18.1659 21.6987V14.6702C18.1659 14.0297 17.647 13.5112 17.0069 13.5112H3.20202V2.87605C3.20202 2.26301 3.70201 1.76307 4.3159 1.76307L14.5103 1.75242V5.52062C14.5103 6.62127 15.4033 7.51517 16.5048 7.51517L20.1962 7.50457L20.2377 24.1463C20.2377 24.7612 19.7387 25.2611 19.1248 25.2611ZM7.24457 20.7262V15.9386C7.64951 15.8741 8.17731 15.8379 8.7343 15.8379C9.65997 15.8379 10.2602 16.004 10.7306 16.3581C11.2367 16.7344 11.5547 17.3343 11.5547 18.1954C11.5547 19.1282 11.2151 19.7722 10.7446 20.1696C10.2314 20.5962 9.45019 20.7986 8.49577 20.7986C7.9242 20.7986 7.51926 20.7624 7.24457 20.7262ZM15.1375 17.8916V18.7882H13.3872V20.7483H12.2808V15.8741H15.2602V16.7777H13.3872V17.8916H15.1375Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconPdf',
  props: {
    width: {
      type: Number,
      default: 45,
    },
    height: {
      type: Number,
      default: 45,
    },
  },
};
</script>

<style scoped>
</style>